import { useMemo } from 'react';
import { Field, FieldTypes } from '@common-fe/common-fe';

import { FieldStateKey, PermissionKey } from '@/common/constants';
import { Option, OptionKey } from '@/common/types';
import useGetPermissionToEditOverridableField from '@/modules/user/hooks/useGetPermissionToEditOverridableField';

import { useHideFields } from '../hooks';

interface Args {
  viewMode: boolean;
  employerId?: OptionKey;
  options: Option[];
  isConfirmSSN?: boolean;
}

export const useEmployerIdFields = (args: Args) => {
  const idSourceIdPermProps = useGetPermissionToEditOverridableField(
    PermissionKey.ID_SOURCE_TYPE,
    FieldStateKey.ID_SOURCE_TYPE,
  );

  const fields = useMemo(() => {
    const {
      viewMode, options, employerId,
    } = args;
    return [
      {
        name: 'eeid',
        type: FieldTypes.Dropdown,
        testId: 'eeid',
        disabled: viewMode,
        singleMode: true,
        placeholder: 'Select',
        options,
        label: 'EEID source',
        value: employerId || '',
        defaultValue: employerId || '',
        ...idSourceIdPermProps,
      },
    ] as Field[];
  }, [args, idSourceIdPermProps]);
  const formattedFields = useHideFields(fields as Field[]);
  return formattedFields;
};
